/** @jsx jsx */
import { jsx } from '@emotion/core';
import React, { useState } from 'react';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Skeleton from 'react-loading-skeleton';
import Button from '@material-ui/core/Button';
import Modal from 'react-modal';
import { makeStyles } from '@material-ui/core/styles';
import {
    tableHeader, fieldRow, searchPagination,
    paginationLeft,
    paginationRight
} from './styles';
import { set } from 'date-fns';

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        height: 'auto',
        width: 'auto'
    }
};

const useStyles = makeStyles((theme) => ({
    root: {

        '& .MuiTableCell-head': {
            backgroundColor: '#e3e4fb',
        },
    },
    tableContainer: {
        maxHeight: 440,
        fontFamily: 'Quicksand, Helvetica, sans-serif !important',
    },
    table: {
        minWidth: 650,
    },
    tableCell: {
        fontFamily: 'Quicksand, Helvetica, sans-serif !important',
    },
    tableRow: {
        cursor: 'pointer',
    },
    tdCell: {
        fontFamily: 'Quicksand, Helvetica, sans-serif !important',
    },
}));

const SoftSavedList = (props) => {
    let { isPartialListAvailable, PartialSavedList, PaginationInfo, loadMetaInfo, accessPermissions, loadSavedClient } = props;
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isRecordId, setRecordId] = useState('');
    const [page, setPage] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(25);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const recordsForPage = [25, 50, 100, 200];


    // Extract headers from the data
    let headers = PartialSavedList.length > 0 ? Object.keys(PartialSavedList[0]) : [];
    headers = headers.filter((item) => item !== '_id');

    const handleDelete = (id) => {
        setRecordId(id);
        setIsModalOpen(true);
    }
    const classes = useStyles();


    const setPageHandler = async (type: number) => {
        setPage(type);
        setPageSize(pageSize);
        let data = { page: type, page_size: pageSize }
        setIsLoading(true)
        await loadMetaInfo(data);
        setIsLoading(false);
    }

    const displayPagination = () => {
        if (PaginationInfo.has_prev === true || PaginationInfo.has_next === true) {
            return true;
        }
        return false;
    }

    const pageSizeHandler = async (e) => {
        const value = parseInt(e.target.value);
        setPage(1);
        setPageSize(value);
        let data = { page: 1, page_size: value }
        setIsLoading(true);
        await loadMetaInfo(data);
        setIsLoading(false);
    }
    return (
        <div className="container-fluid mb-5" style={{ marginTop: '3rem' }}>
            <TableContainer component={Paper} className={classes.tableContainer}>
                <Table aria-label="clients table" className={classes.table}>
                    <TableHead className={classes.root}>
                        <TableRow css={tableHeader}>
                            {headers.map((header) => (
                                <TableCell key={header}>{header}</TableCell>
                            ))}
                            <TableCell key={`Action`}>Action</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {(!isLoading && PartialSavedList.length > 0) ? PartialSavedList.map((item: any, i) => (
                            <TableRow
                                key={i}
                            //    css={tableRow}
                            >
                                {headers.map((header) => (
                                    <React.Fragment>
                                        <TableCell key={header}>{item[header]}</TableCell>
                                    </React.Fragment>
                                ))}
                                <React.Fragment>
                                    <TableCell key={i}>
                                        {accessPermissions.includes("Edit Partial Data") && (
                                            <u
                                                onClick={() => (
                                                    loadSavedClient(item._id, 'get'))}
                                                style={{ cursor: 'pointer' }}
                                            >
                                                Edit
                                            </u>
                                        )}
                                        {' '}
                                        {accessPermissions.includes("Delete Partial Data") && (
                                            <u
                                                onClick={() => handleDelete(item._id)}
                                                style={{ cursor: 'pointer' }}
                                            >
                                                Delete
                                            </u>
                                        )}
                                    </TableCell>
                                </React.Fragment>
                            </TableRow>
                        )) : (
                            <TableRow key={9999}>
                                {isLoading ? (
                                    <React.Fragment>
                                        <TableCell key={1} colSpan={4} style={{ textAlign: 'center' }}>
                                            <h1>
                                                <Skeleton key={1} height="60px" />
                                            </h1>
                                            <Skeleton key={1} height="25px" />
                                        </TableCell>
                                    </React.Fragment>
                                ) : (
                                    <TableCell key={1} colSpan={4} style={{ textAlign: 'center' }}>
                                        No results found
                                    </TableCell>
                                )}
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
            <br />

            <div css={searchPagination}>
                <div css={paginationLeft}>
                    <span>Page: {page}</span>
                    <span>Page Size: </span>
                    <select name="page_size" onChange={(e) => pageSizeHandler(e)} >
                        {recordsForPage.map((size) => (
                            <option key={size} value={size} >
                                {size}
                            </option>
                        ))}
                    </select>
                </div>
                {displayPagination() && (
                    <div css={paginationRight}>
                        <Button
                            disabled={!PaginationInfo.has_prev}
                            onClick={() => setPageHandler(page - 1)}>Previous</Button>
                        <Button
                            disabled={!PaginationInfo.has_next}
                            onClick={() => setPageHandler(page + 1)}>Next</Button>
                    </div>
                )}
            </div>

            <Modal
                isOpen={isModalOpen}
                ariaHideApp={false}
                onRequestClose={() => setIsModalOpen(false)}
                style={customStyles}
                contentLabel="Alert Modal"
            >
                <div>
                    Are you sure you want to Delete?
                </div>
                <br />
                <div css={fieldRow}>
                    <div style={{ justifyContent: 'flex-start' }}>
                        <Button
                            type="submit"
                            size="large"
                            variant="contained"
                            color="primary"
                            onClick={() => props.loadSavedClient(isRecordId, 'delete')}
                        >
                            Yes
                        </Button>
                    </div>
                    <div style={{ justifyContent: 'right' }} onClick={() => setIsModalOpen(false)}>
                        <Button type="submit" size="large" variant="contained" color="primary">
                            No
                        </Button>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default SoftSavedList;